import { handleActions } from 'redux-actions';
import http from '../shared/http';
import intl from '../shared/intl';
import endpoints from '../../config/endpoints';

import cloneDeep from 'lodash/cloneDeep';

// action types
const GET_MANAGER_ERROR  = 'survey/get-manager-error';
const GET_MANAGER_SUCCESS = 'survey/get-manager-success';

// initialState state
const initialState = {
	data: {}
};

// actions
export const actions = {
	getManager: () => (dispatch, getState) => {
		let urls = [];
		if (process.env.CPA_ENV === 'everad') {
			urls.push(endpoints.PROFILE.MANAGER);
		}

		http({
			url: urls,
			method:'get',
			actions:[
				GET_MANAGER_SUCCESS,
				GET_MANAGER_ERROR
			]
		})(dispatch);
	}
};

// reducers
const reducers = {
	[GET_MANAGER_SUCCESS]: (state, action) => {
		return {
			...state,
			data: action.payload[0].data
		};
	},
	[GET_MANAGER_ERROR]: state => {
		return { ...state, error: true };
	}
};

export default handleActions(reducers, cloneDeep(initialState));

// selectors
export const selectors = {
	getManager: state => state.manager.data,
	getTrafficSources: state => state.app.lists['traffic-sources'],
	getUserData: state => state.app.userData,
	getIntl: state => intl(state)
};



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/manager/index.js